/*global REACT_APP_API_BASE_URL_NEW:true*/
import request from "@/utils/request";
import { cleanObjectFromUndefined } from "@/utils/utils";

export async function getDealers({ page = 1, pageSize = 10, filter = "", sorting }) {
  page--;

  const SkipCount = page * pageSize;
  const params = cleanObjectFromUndefined({
    SkipCount,
    MaxResultCount: pageSize,
    FilterText: filter || undefined,
    sorting: sorting ?? undefined,
  });

  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/nissan-service/dealers`, {
    method: "GET",
    params,
  });

  return result.data;
}

export async function createDealer(params) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/nissan-service/dealers`, {
    method: "POST",
    data: params,
  });

  if (result?.error) {
    throw new Error(result?.error);
  }

  return result?.data;
}

export async function updateDealer(params) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/nissan-service/dealers/${params.id}`, {
    method: "PUT",
    data: params,
  });

  if (result?.error) {
    throw new Error(result?.error);
  }

  return result?.data;
}

export async function deleteDealer(id) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/nissan-service/dealers/${id}`, {
    method: "DELETE",
  });

  if (result?.error) {
    throw new Error(result?.error);
  }

  return result?.data;
}
